import { createSelector } from 'reselect';
import type { RootState } from 'typesafe-actions';

import type { CountriesState } from './reducer';

export const getCountriesState = (state: RootState) => state.countries;

export const getCountries = createSelector(
  getCountriesState,
  (state: CountriesState) => state.items,
);
